import { call, put } from "redux-saga/effects";
import { requestCreateRequest, requestGetAllActiveRequests, requestGetPartRequestCount } from "../requests/partRequest";
import { setAllActiveRequests, setPartRequestCount } from "../../entities/partRequest";

export function* handleGetPartRequestCount(_action) {
    try {
        const response = yield call(requestGetPartRequestCount);
        const { data } = response;
        yield put(setPartRequestCount(data));
    } catch (error) {
        console.log(error);
    };
};

export function* handleGetAllActiveRequests(action) {
    try {
        const response = yield call(requestGetAllActiveRequests, action.payload);
        const { data } = response;
        yield put(setAllActiveRequests({ ...data }));
    } catch (error) {
        console.log(error);
    }
}

export function* handleCreateRequest(action) {
    try {
        yield call(requestCreateRequest, action.payload);
    } catch (error) {
        console.log(error);
    }
}